export default __webpack_public_path__ + "static/media/cancellation-offer-modal.b22dba60.webp";